export class TemplateDateInspectionInput {
    description = '';
    constructor(dateInspection) {
        if (dateInspection) {
            this.description = dateInspection.description;
        }
    }
}
